// removed by extract-text-webpack-plugin
module.exports = {"Map":"Map__Map___3t5NH","MapInfo":"Map__MapInfo___EXyFo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buildings/Map/Map.scss
// module id = 1316
// module chunks = 0